var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 23,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_369_376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4025 18.5961C20.8318 17.2528 19.2378 16.439 17.6865 17.7804L16.7601 18.5911C16.0823 19.1796 14.8222 21.9292 9.94988 16.3244C5.07862 10.7266 7.97743 9.85507 8.65622 9.27166L9.58766 8.45995C11.1309 7.11556 10.5485 5.42315 9.43546 3.68103L8.76377 2.62581C7.64565 0.887738 6.42808 -0.253726 4.88077 1.08864L4.04471 1.81917C3.36085 2.31736 1.44927 3.93671 0.985587 7.01308C0.427538 10.7043 2.18793 14.9313 6.2211 19.5692C10.2492 24.2091 14.1931 26.5397 17.929 26.4991C21.0337 26.4657 22.9088 24.7996 23.4952 24.1939L24.3343 23.4623C25.8776 22.121 24.9188 20.7553 23.3471 19.4089L22.4025 18.5961Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_369_376"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/call-icon.4c425292abeeefec0acb579ddfbcae4b.svg";
export { ForwardRef as ReactComponent };